import React, { useState, useEffect } from "react";
import Form from "react-bootstrap/Form";
import StatisticBarChart from "../../components/chart/Barchart";
import { useStore } from "../../store";
import { getReportAmount, getReportMember, getStatisticReport } from "../../services/report.service";
import convertNumber from "../../helpers/convertNumber";

const ReportPage = () => {
      // store
  const { token, profile,} = useStore();
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [years, setYears] = useState([]);
  const [isLoading, setIsLoading] = useState({amount:false,member:false,loanStatistic:false});
  const [reportAmount, setReportAmount] = useState(null);
  const [reportMember,setReportMember] = useState(null);
  const [reportStatistic,setReportStatistic] = useState(null);

// ------------------------------------------useEffect-----------------------------------------
  useEffect(() => {
    generatePastFiveYears();
  }, []);

  useEffect(() => {
    if(selectedYear && profile?.branchId && token){
      fetchingAmountReport();
      fetchingMemberReport();
      fetchStatisticReport();
    }
  }, [selectedYear]);

useEffect(() => {
 if(reportStatistic){
  console.log("reportStatistic", reportStatistic);
 }
}, [reportStatistic]);

  const handleYearChange = (e) => {
    const year = Number(e.target.value);
    setSelectedYear(year);
    console.log("Selected Year:", year);
    // You can trigger filter logic here
  };

  //    generatePastFiveYears
  const generatePastFiveYears = () => {
    const currentYear = new Date().getFullYear();
    const yearList = Array.from(
      { length: 5 },
      (_, index) => currentYear - index
    );
    setYears(yearList);
  };

// ----------------------------------------------------function fetching data from server --------------------------------------------------

const fetchingAmountReport = async () => {
  try {
    setIsLoading({...isLoading,amount:true});
    const result = await getReportAmount(profile?.branchId,selectedYear,token);
    console.log("result", result);
    setReportAmount(result);
  } catch (err) {
    // setError(err.message);
    console.error("Error fetching installment data:", err);
  } finally {
    setIsLoading({...isLoading,amount:false});
  }
};

const fetchingMemberReport = async () => {
  try {
    setIsLoading({...isLoading,member:true});
    const result = await getReportMember(profile?.branchId, selectedYear,token);
    console.log("member", result);
    setReportMember(result);
  } catch (err) {
    // setError(err.message);
    console.error("Error fetching installment data:", err);
  } finally {
    setIsLoading({...isLoading,member:false});
  }
}

const fetchStatisticReport = async () => {
  try {
    setIsLoading({...isLoading,loanStatistic:true});
    const result = await getStatisticReport(profile?.branchId,selectedYear,token);
    console.log("member", result);
    setReportStatistic(result);
  } catch (err) {
    // setError(err.message);
    console.error("Error fetching installment data:", err);
  } finally {
    setIsLoading({...isLoading,loanStatistic:false});
  }
}
















  return (
    <div>
      <div className="d-flex justify-content-between align-items-center">
        <div>
          <h4>ລາຍງານສະຖິຕິພາບລວມຂອງລະບົບ</h4>
        </div>
        <div>
          <Form.Label>ສະເເດງຕາມປີ</Form.Label>
          <Form.Select
            className="w-100"
            value={selectedYear}
            onChange={handleYearChange}
          >
            {years?.map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </Form.Select>
        </div>
      </div>
      <div className="card-container">
        <div className="num-card">
          <h3 className="title">ຈໍານວນເງີນປອ່ຍກູ້</h3>
          {isLoading?.amount ? <div className="loader"></div>:
          <p className="amount">{convertNumber(reportAmount?.totalPrincipalAmount)} ກີບ</p>}
        </div>
        <div className="num-card">
          <h3 className="title">ຈໍານວນເງີນຕົ້ນທືນທີເກັບຄືນໄດ້</h3>
          {isLoading?.amount ? <div className="loader"></div>:<p className="amount">{convertNumber(reportAmount?.paidPrincipalAmount)} ກີບ</p>}
        </div>
        <div className="num-card">
          <h3 className="title">ຈໍານວນເງີນກໍາໄລ</h3>
         {isLoading?.amount ? <div className="loader"></div>: <p className="amount">{convertNumber(reportAmount?.totalIncome)} ກີບ</p>}
        </div>
        <div className="num-card">
          <h3 className="title">ຈໍານວນລູກໜີ້</h3>
         {isLoading?.member ? <div className="loader"></div>: <p className="amount">{convertNumber(reportMember?.totalLoanMembers)} ຄົນ</p>}
        </div>
      </div>
      <div className=" m-4">
       {isLoading?.loanStatistic && <div className="w-100 d-flex justify-content-center"><div className="loader"/></div>}
       {reportStatistic && !isLoading?.loanStatistic && <StatisticBarChart data={reportStatistic}/>}
      </div>
    </div>
  );
};

export default ReportPage;
